import { ADD_TEXTBOX, CLEAR_TEXTBOXES, LOADING_TEXTBOX, STOP_LOADING_TEXTBOX } from '../types'

const initialState = {
  loading: false,
  textboxes: [],
}

const textboxReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TEXTBOX:
      let font = ''
      const fFamily = action.payload.fontFamily === 'Times Roman' ? 'Times' : action.payload.fontFamily
      const fWeight = action.payload.fontWeight === 'Normal' ? '' : action.payload.fontWeight
      const fStyle = action.payload.fontStyle === 'Normal' ? '' : action.payload.fontStyle
      if (fWeight === '' && fStyle === '')
        if (fFamily === 'Times') font = 'Times-Roman'
        else font = fFamily
      else font = fFamily + '-' + fWeight + fStyle
      return {
        ...state,
        textboxes: [
          ...state.textboxes,
          {
            value: action.payload.value,
            font,
            fontSize: action.payload.fontSize,
            color: action.payload.color,
            tbLeft: action.payload.tbLeft,
            tbTop: action.payload.tbTop,
            tbHeight: action.payload.tbHeight,
            pageNumber: action.payload.pageNumber,
            offsetLeft: action.payload.offsetLeft,
            offsetTop: action.payload.offsetTop,
            multiplier: action.payload.multiplier,
            pageHeight: action.payload.pageHeight,
          },
        ],
      }

    // return [
    //   ...state,
    //   {
    //     value: action.payload.value,
    //     font,
    //     fontSize: action.payload.fontSize,
    //     color: action.payload.color,
    //     tbLeft: action.payload.tbLeft,
    //     tbTop: action.payload.tbTop,
    //     tbHeight: action.payload.tbHeight,
    //     pageNumber: action.payload.pageNumber,
    //     offsetLeft: action.payload.offsetLeft,
    //     offsetTop: action.payload.offsetTop,
    //     multiplier: action.payload.multiplier,
    //     pageHeight: action.payload.pageHeight,
    //   },
    // ]
    case CLEAR_TEXTBOXES:
      return initialState

    case LOADING_TEXTBOX:
      return {
        ...state,
        loading: true,
      }

    case STOP_LOADING_TEXTBOX:
      return {
        ...state,
        loading: false,
      }

    default:
      return state
  }
}

export default textboxReducer
